import { LinkAuthMethodStrategy } from './link-auth-method-strategy.inteface';
import { AuthMethod } from '../../../account-window/parts/auth-method';
import { HubApi } from '@scorewarrior/rubens_web_lib/lib/hub-api/hub-api';
import {
    LinkAuthMethodGoogleRequest,
    LinkAuthMethodGoogleResponse
} from '@scorewarrior/rubens_web_lib/lib/hub-api/protocol/link-auth-method-google.protocol';

export class LinkAuthMethodGoogleStrategy implements LinkAuthMethodStrategy {
    static authMethod = AuthMethod.GOOGLE;
    constructor(private hubApi: HubApi) {}

    link(deviceId: string, params: LinkAuthMethodGoogleRequest): Promise<LinkAuthMethodGoogleResponse> {
        return this.hubApi.linkAuthMethodGoogle(deviceId, params);
    }
}
